import { useContext } from 'react'
import { ErrorBannerContext } from '@/root/shared-providers'

export const useErrorBanner = () => {
  return useContext(ErrorBannerContext)
}
